import initSlickSlider from '../utils/initSlickSlider';
import setEqualHeight from '../utils/setEqualHeight';
import { COMMON_SLICK_SLIDER_OPTIONS, BREAKPOINT } from '../utils/constants';

const selectors = {
    sliderWrapper: '.js-vacancies-slider-parent',
    slider: '.js-vacancies-slider',
    slide: '.js-vacancies-slide',
    card: '.js-vacancies-card',
    dotsContainer: '.js-slick-slider-navigation-dots',
    prevArrow: '.js-slick-slider-prev-btn',
    nextArrow: '.js-slick-slider-next-btn'
};

const setDelayedEqualHeight = ($slider) => () => {
    setTimeout(() => {
        const $slides = $slider.find(selectors.card);
        setEqualHeight($slides);
    }, 0); // a zero delay to let the slider finish its calculations
};

const vacanciesSlider = () => {
    const $slider = $(selectors.slider);

    if (!$slider) {
        return;
    }

    const prevArrow = $slider.closest(selectors.sliderWrapper).find(selectors.prevArrow);
    const nextArrow = $slider.closest(selectors.sliderWrapper).find(selectors.nextArrow);
    const dotsContainer = $slider.closest(selectors.sliderWrapper).find(selectors.dotsContainer);

    const options = $.extend({}, COMMON_SLICK_SLIDER_OPTIONS, {
        prevArrow,
        nextArrow,
        appendDots: dotsContainer,
        responsive: [
            {
                breakpoint: BREAKPOINT.TABLET - 1,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: BREAKPOINT.OLD_FASHION_DESKTOP - 1,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: BREAKPOINT.DESKTOP - 1,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    const setSlidesEqualHeight = setDelayedEqualHeight($slider);

    $slider.on('init', () => {
        setSlidesEqualHeight();
    });

    $slider.on('breakpoint', setSlidesEqualHeight);

    initSlickSlider($slider, options);
};
export default vacanciesSlider;
